import ExlyModal from "common/Components/ExlyModal";
import React from "react";
import { useActionFieldModalWrapper } from "./utils/useActionFieldModalWrapper";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";

export const ActionFieldModalWrapper = withComponentLibraryTheme(
  ({ children }) => {
    const { isActionFieldsModalOpen, closeActionFieldModal } =
      useActionFieldModalWrapper();

    return (
      <ExlyModal
        open={isActionFieldsModalOpen}
        onClose={closeActionFieldModal}
        customHeader={<></>}
        customFooter={<></>}
        padded={false}
        backDropClickClose
        escapeKeyDownClose
      >
        {children}
      </ExlyModal>
    );
  }
);
